import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

export const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="about-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="font-['Bodoni_Moda'] text-4xl sm:text-5xl font-bold text-[#2A2A2A] mb-8">
          Built for Real Kitchens.
        </h1>

        <div className="prose prose-lg max-w-none">
          <div className="space-y-6 text-[#444] leading-relaxed">
            <p className="text-lg sm:text-xl">
              Country Bo is bold flavor without overthinking. We started with a simple idea: great food shouldn't require a culinary degree or a pantry full of specialty ingredients. Just the right blend, at the right time, on the right dish.
            </p>

            <p className="text-lg sm:text-xl">
              Every blend is designed to make food taste better fast. Whether you're a home cook trying to level up weeknight dinners, or a seasoned grill master looking for that perfect finishing touch—Country Bo delivers. No fuss. No complicated recipes. Just big, bold flavor that makes everything taste like you know exactly what you're doing.
            </p>

            <p className="text-lg sm:text-xl">
              We believe in simple, high-quality ingredients that work hard so you don't have to. Each of our four signature blends has been crafted, tested, and perfected to bring out the best in your food—whether you're searing steaks, roasting vegetables, or frying up seafood.
            </p>
          </div>

          <div className="mt-12 p-8 bg-[#2A2A2A] rounded-2xl text-center">
            <h2 className="font-['Bodoni_Moda'] text-2xl sm:text-3xl font-bold text-white mb-4">
              Ready to taste the difference?
            </h2>
            <p className="text-[#B8B5B0] mb-6">
              Put Some Bo On It.™
            </p>
            <Link to="/shop">
              <Button
                size="lg"
                className="bg-[#D4540A] hover:bg-[#B84709] text-white px-8 py-6 text-lg font-semibold"
                data-testid="shop-cta"
              >
                Shop the Blends
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
